import { createContext, useContext } from 'react';

/** Which dataset the QXO page is focused on. Null means the full desk. */
export interface QxoFocusValue {
  focusId: string | null;
  open: (id: string) => void;
}

export const QxoFocusContext = createContext<QxoFocusValue>({
  focusId: null,
  open: () => {},
});

export function useQxoFocus(): QxoFocusValue {
  return useContext(QxoFocusContext);
}

/** Props for a Recharts XAxis. Pass them onto <XAxis> directly — Recharts ignores a wrapper component.
 * `focusEvery` is how many ticks to skip on the long view (3 ≈ one label a year on quarterly data). */
export function timeAxisProps(open: boolean, interval: number, focusEvery = 0) {
  if (open) {
    return {
      interval: focusEvery,
      tick: { fill: '#93c5fd', fontSize: 9 },
      angle: -50,
      textAnchor: 'end' as const,
      height: 58,
      axisLine: false as const,
      tickLine: false as const,
    };
  }
  return {
    interval,
    tick: { fill: '#93c5fd', fontSize: 10 },
    height: 30,
    axisLine: false as const,
    tickLine: false as const,
  };
}
